<template>
  <v-container fluid>
    <div class="">
      <v-btn
        @click="$emit('edit-program', 'program-form', {})"
        class="mx-0 my-3"
        outline
        color="primary"
        v-if="amazeUserCan('administer', 'dsec_calendar')"
        ><v-icon class="pr-2" small>fa fa-plus</v-icon>Add Program</v-btn
      >
    </div>
    <div>
      <v-layout>
        <v-flex class="pa-2" sm12 md3>
          <v-text-field
            id="keywordFilter"
            clearable
            label="Search Program Name"
            placeholder="Enter keyword to search program names"
            v-model="form.filter"
            @click:clear="init()"
            @keydown.enter="doSearch()"
          >
          </v-text-field>
        </v-flex>
        <v-flex class="pa-2" sm12 md3>
          <v-select
            label="DSEC Partner"
            v-model="form.partner"
            :items="dsecPartners"
            item-text="name"
            item-value="id"
            clearable
            @change="doSearch"
          ></v-select>
        </v-flex>
      </v-layout>
    </div>
    <!-- DATA TABLE -->
    <v-data-table
      v-if="!loading"
      :headers="headers"
      :items="sortedPrograms"
      :pagination.sync="tablePagination"
      :loading="loading"
      :rows-per-page-items="rowsPerPage"
      sort-icon="arrow_drop_down"
      class="elevation-1 amaze-data-table"
    >
      <template slot="items" slot-scope="props">
        <td class="larger">{{ props.item.name }}</td>
        <td class="larger">
          <v-chip
            :class="'t-' + props.item.dsec_partner_name"
            label
            small
            v-if="props.item.dsec_partner_name"
            disabled
            >{{ props.item.dsec_partner_name }}</v-chip
          >
        </td>
        <td class="text-right layout px-0 cardActions">
          <v-menu class="cardMenu hidden-md-and-up" bottom left>
            <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
            <v-list>
              <div v-if="amazeUserCan('administer', 'dsec_calendar')">
                <v-list-tile
                  v-on:click="$emit('edit-program', 'program-form', props.item)"
                >
                  <v-list-tile-title>Edit Program</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="deleteProgram(props.item)">
                  <v-list-tile-title>Delete Program</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list>
          </v-menu>
          <v-tooltip top v-if="amazeUserCan('administer', 'dsec_calendar')">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  class="hidden-sm-and-down amaze-user-action"
                  slot="activator"
                  @click="$emit('edit-program', 'program-form', props.item)"
                  icon
                  ><v-icon>$vuetify.icons.amaze-edit</v-icon></v-btn
                >
              </div>
            </template>
            <span>Edit Program</span>
          </v-tooltip>
          <v-tooltip top v-if="amazeUserCan('administer', 'dsec_calendar')">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  class="hidden-sm-and-down amaze-user-action"
                  slot="activator"
                  @click="deleteProgram(props.item)"
                  icon
                  ><v-icon>$vuetify.icons.amaze-delete</v-icon></v-btn
                >
              </div>
            </template>
            <span>Delete Program</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data">
        <!-- <v-btn
            color="primary"
            @click="getUsersFromApi">Reset</v-btn> -->
      </template>
    </v-data-table>
    <!-- END DATA TABLE -->
    <div v-else>
      <div class="text-xs-center py-4">
        <h4>
          <v-icon class="mr-2">fas fa-circle-notch fa-spin</v-icon> Loading
        </h4>
      </div>
    </div>
  </v-container>
</template>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";
import _ from 'lodash'
export default {
  mixins: [permissionsMixin],
  data() {
    return {
      programs: [],
      partners: [],
      editProgramObject: {},
      loading: false,
      form: {
        filter: "",
        partner: ""
      },
      headers: [
        { text: 'Program', value: 'name', width: "30%" },
        { text: 'Partner', value: 'dsec_partner_name' },
        { text: '', value: null, sortable: false, align: 'center' }
      ],
      tablePagination: {
        rowsPerPage: 15
      },
      rowsPerPage: [15]
    };
  },
  computed: {
    totalPrograms() {
      return this.programs.length;
    },
    dsecPartners() {
      return this.partners ? this.partners.map(partner => {
        return {
          name: partner.name,
          id: partner.id
        };
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];
    },
    sortedPrograms() {
      let sortBy = this.tablePagination.sortBy;
      let sortDir = this.tablePagination.descending ? -1 : 1;
      let sorted = this.programs.slice(0);

      // Sorted items have an attribute called partner that is itself an object.
      // The attributes of the partner object need to be moved up to the program object
      // with the prefix 'dsec_partner_' so that they can be sorted.
      sorted.forEach((program) => {
        if (program.dsec_partner) {
          program.dsec_partner_name = program.dsec_partner.name;
        }
      });

      // filter the sorted items based on the filter text and partner.
      if (this.form.filter || this.form.partner) {
        sorted = sorted.filter((item) => {
          let partnerMatches = (!this.form.partner || item.dsec_partner_id === this.form.partner);
          let nameMatches = (!this.form.filter || item.name.toLowerCase().includes(this.form.filter.toLowerCase()));

          return partnerMatches && nameMatches;
        });
      }

      if (sortBy) {
        sorted.sort((a, b) => { return a[sortBy].toUpperCase() < b[sortBy].toUpperCase() ? -1 * sortDir : 1 * sortDir; });
      }

      return sorted;
    }
  },
  methods: {
    init() {
      this.form.filter = "";
    },
    async getPartners() {
      if (this.partners && this.partners.length) {
        return;
      }
      this.loading = true;
      let partners = await this.$http.get("dsec/partners");
      this.partners = partners.body;
      this.loading = false;
    },
    doSearch() {
      // this.loading = true;
      // this.getPrograms();
    },
    newProgram() {
      this.editProgramObject = {};
      this.programDialog = true;
    },
    editProgram(item) {
      this.editProgramObject = item;
      this.ac_results = item.users;
      this.programDialog = true;
    },
    getPrograms: _.debounce(async function() {
      this.loading = true;
      let programs = await this.$http.get("dsec/program");
      this.programs = programs.body;
      this.loading = false;
    }, 500),
    async deleteProgram(program) {
      if (
        confirm(
          "Are you sure?"
        )
      ) {
        this.loading = true;
        let result = await this.$http.delete("dsec/program/" + program.id);
        if (result.status === 200) {
          this.getPrograms();
        } else {
          console.log("[ERROR] Program not deleted");
        }
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getPrograms();
    this.getPartners();
    EventBus.$on("refreshPrograms", this.getPrograms);
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/dsec-labels.scss";
.v-btn--flat {
  font-weight: normal;
}
</style>
